import React, { useEffect, useState } from "react";
import Footer from "@/components/UI/Footer";
import "@arco-design/web-react/dist/css/arco.css";
import LoginForm from "./form";
import LoginBanner from "./banner";
import "./style/style.less";
import loginimg from "@/assets/Logo/logo.png";
import { badge, close, minimize, zoom_max, zoom_min } from "@/assets/workbenchimage";
import { observer } from "mobx-react";
import appStore from "@/stores/appStore";
import LoadingGIF from "@/components/UI/LoadingGIF";
import { useNavigate, useSearchParams } from "react-router-dom";
import ZxLogo from '@/assets/zx-logo.png';
function Login() {
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const [submitTime] = useState("2024-11-28 20:33/test");
  const [isMaximized, setIsMaximized] = useState(false);

  const checkAppleSystem = () => {
    const userAgent = navigator.userAgent || navigator.vendor;
    // 使用类型断言来绕过类型检查
    if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
      return true;
    } else if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
      return true;
    } else {
      return false;
    }
  };
  const handleMinimize = () => {
    window.electron.ipcRenderer.windowControl.minimize();
  };

  const handleMaximize = () => {
    window.electron.ipcRenderer.windowControl.maximize();
  };

  const handleClose = () => {
    window.electron.ipcRenderer.windowControl.close();
  };
  useEffect(() => {
    window.localStorage.clear();
  }, []);
  useEffect(() => {
    // 监听主进程传来的窗口状态变化
    if (window && window.electron) {
      window.electron.ipcRenderer.windowStateChanged((state) => {
        setIsMaximized(state);
      });
    }

    // 清理事件监听器
    return () => {
      if (window && window.electron) {
        window.electron.ipcRenderer.removeListener("window-state-changed", () => {
          //
        });
      }
    };
  }, []);
  const [search] = useSearchParams();
  const adminToken = search.get("token");
  const target_url = search.get("target_url");
  useEffect(() => {
    if (adminToken) {
      window.localStorage.clear();
      window.localStorage.setItem("Token", adminToken);
      navigate(target_url ? target_url : "/");
    }
  }, [adminToken]);
  return (
    <div className="container">
      {window && window.electron ? (
        <div className="clent-tool" style={{ display: checkAppleSystem() ? "none" : "flex" }}>
          <div onClick={handleMinimize}>
            <img src={minimize} alt="" />
          </div>
          <div onClick={handleMaximize}>
            <img src={isMaximized ? zoom_min : zoom_max} alt="" />
          </div>
          <div onClick={handleClose}>
            <img src={close} alt="" />
          </div>
        </div>
      ) : (
        <></>
      )}

      {appStore.isInFrame}

      {!appStore.isInFrame ? (
        <>
          <div
            className="version"
            onClick={() => {
              setCount(count + 1);
            }}
          >
            {count > 10 ? submitTime : ""}
          </div>
          <div className="logo">
            <img
              src={ZxLogo}
              className="login_contel_itemIMG"
              alt=""
            />
          </div>
          <div className="banner">
            <div className="inner">
              <LoginBanner />
            </div>
          </div>
          <div className="content">
            <div className="inner">
              <div>&emsp;</div>
              <div>&emsp;</div>
              <LoginForm />
              <div className="icp-info">
                {!!appStore.config?.web?.app?.copyright_text && <p>{appStore.config?.web?.app?.copyright_text}</p>}
                {!!appStore.config?.web?.app?.icp_date && (
                  <p>
                    <a target="_blank" href="https://beian.miit.gov.cn" style={{ color: "#9e9e9e" }}>
                      {appStore.config?.web?.app?.icp_date}
                    </a>
                    &emsp;|&emsp;
                    <img src={badge} width={13} alt="" />
                    &nbsp; {appStore.config?.web?.app?.icp_no}
                  </p>
                )}
              </div>
            </div>
            <div className="footer">
              <Footer />
            </div>
          </div>
        </>
      ) : (
        <div className="auth-loading">
          <LoadingGIF />
          <div className="text">授权登录中 {process.env.AID}</div>
        </div>
      )}
    </div>
  );
}
Login.displayName = "LoginPage";

export default observer(Login);
